import styled from 'styled-components';
var ErrorContainer = styled.div.withConfig({
  displayName: "ErrorContainer",
  componentId: "sc-1nw03ru-0"
})(["margin-top:0.125rem;"]);
export default ErrorContainer;